module.exports = __webpack_public_path__ + "static/img/2018.7f29669.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2018.jpg
// module id = t/1H
// module chunks = 1